import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/functions";
import "firebase/storage";

const config = {
  apiKey: "AIzaSyCJfKcc_OyA0rv-jA9yH_HC7PDi8PylfCc",
  authDomain: "just-in-north.firebaseapp.com",
  databaseURL: "https://just-in-north.firebaseio.com",
  messagingSenderId: "581547763015",
  projectId: "just-in-north",
  storageBucket: "just-in-north.appspot.com"
};

firebase.initializeApp(config);

export const auth = firebase.auth();

export const facebookProvider = new firebase.auth.FacebookAuthProvider();
export const googleProvider = new firebase.auth.GoogleAuthProvider();

export const firestore = firebase.firestore();
firestore.settings({ timestampsInSnapshots: true });
// @ts-ignore
// firestore.enablePersistence({ experimentalTabSynchronization: true });

export default firebase;



// WEBPACK FOOTER //
// ./src/firebase.ts